import { takeLatest } from 'redux-saga/effects';
import {
  getOvertimeListSuccess, getOvertimeListFail,
  getOvertimeDetailsSuccess, getOvertimeDetailsFail
} from './overtimeState';
import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/timekeeping/overtimes');
const redirectData = {route:'/console/overtimes', mode: 'list', recordId:0 };
const modelName = 'Overtime';
const modelId = 'ots_id';

function* getOvertimeList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getOvertimeListSuccess, 
		getOvertimeListFail, null, null, LOADING_MSG);
}

function* getOvertimeDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getOvertimeDetailsSuccess, 
		getOvertimeDetailsFail, null, null, LOADING_MSG);		
}

function* doOvertimeCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getOvertimeDetailsSuccess, 
		getOvertimeDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		SAVING_MSG);
}

function* doOvertimeUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getOvertimeDetailsSuccess, 
		getOvertimeDetailsFail,
		updateRecordSuccess(modelName),
		{...redirectData, mode: "reload" },
		UPDATING_MSG);	
}

function* doOvertimeDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getOvertimeDetailsSuccess, 
		getOvertimeDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);
}

function* overtimeSaga() {
  yield takeLatest('overtime/getOvertimeList', getOvertimeList);
  yield takeLatest('overtime/getOvertimeDetails', getOvertimeDetails);
  yield takeLatest('overtime/doOvertimeCreate', doOvertimeCreate);
  yield takeLatest('overtime/doOvertimeUpdate', doOvertimeUpdate);
  yield takeLatest('overtime/doOvertimeDelete', doOvertimeDelete);  
}

export default overtimeSaga;
